<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 :fullscreen="$vuetify.breakpoint.xsOnly" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 Add reject reason
      v-spacer
      v-btn(icon @click="showDialog = false" small color="primary")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.pa-8
      .mb-4.text-md.font-semibold Fill the information below
      .text-sm.font-semibold.neutral500--text.mb-2 Reject reason
      template(v-for="(reason, index) in reasons")
        .d-flex.align-center.mb-4
          v-text-field.round-xl(v-model="reason.name" placeholder="Enter reject reason" outlined hide-details)
          v-btn.ml-4(icon color="primary" @click="deleteReason(reason)" v-if="reason.name")
            v-icon $yzi-trash-04
      v-btn.button-sm(outlined @click="addReason" :disabled="emptyReasons") 
        v-icon.ml-n2(color="neutral700" left) $yzi-plus
        span Add reject reason
    v-divider

    v-card-actions.py-4.pr-6
      v-btn.button-md.primary400--text.underline(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="save" :loading="isLoading" color="primary" depressed :disabled="emptyReasons") {{ $t('save') }}
</template>


<script>
import { mapGetters, mapActions } from 'vuex'
import CreateRejectReasonDialog from './CreateRejectReasonDialog.vue';

export default {
  name: 'AddRejectReasonDialog',
  components: { CreateRejectReasonDialog },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    rejectStatus: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    status: null,
    isLoading: false,
    reasons: [{ name: '' }]
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    emptyReasons () {
      return this.reasons.filter(item => item.name.trim().length === 0).length > 0
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    deleteReason (reason) {
      if (this.reasons.length === 1) {
        this.reasons.map(item => item.name = '')
        return
      }
      this.reasons = this.reasons.filter(item => item !== reason)
    },
    addReason () {
      this.reasons.push({ name: ''})
    },
    async save () {
      this.isLoading = true
      let hasError = false
      await this.asyncForEach(this.reasons, async (status) => {
        try {
          const params = { name: status.name }
          await this.$axios.post(`/connect/${this.company.slug}/statuses/${this.rejectStatus.id}/reasons`, params)
        } catch (error) {
          hasError = true
          let message = this.$t('error_message.unable_to_complete_request')
          if (error.response.data?.detail) {
            message = error.response.data.detail
          }
          this.showMessage(['error', message])
        }
      })
      if (!hasError) {
        this.showMessage(['success', 'Reasons successfully added'])
      }      
      this.isLoading = false
      this.showDialog = false
      this.$emit('added')
    }
  }
}
</script>
